import { useOnboardingContext } from '../context/OnboardingContext';
import ProgressBar from './ProgressBar';

export default function OnboardingHeader() {
	const { currentPage } = useOnboardingContext();

	const headerEmoji = {
		OUTREACH: '🚀',
		OFFERING: '👋',
		VALUE: '🔥',
		SIGNATURE: '👏',
		GENERATING: '🎉'
	};

	const emoji = (currentPage !== 'WELCOME' && headerEmoji[currentPage]) || '';

	return (
		<div className="to-dark-grayish h-[4.375rem] w-full overflow-hidden rounded-lg border-b border-dm-gold bg-gradient-to-b from-dm-black px-7 sm:px-20 lg:rounded-br-none lg:rounded-tr-none">
			{currentPage !== 'WELCOME' && (
				<div className="flex h-full w-full flex-col items-center justify-center">
					<div className="mx-auto flex w-full max-w-[79rem] flex-col gap-2 pb-2 pt-4">
						<h1 className="flex items-center justify-center gap-1 whitespace-nowrap text-center font-barlow text-sm font-semibold leading-[1.188] text-dm-gold sm:justify-start sm:text-left">
							You&apos;re one step closer to sending your first
							email!
							<span className="inline-block h-[1.25rem] w-[1.188rem]">
								{emoji}
							</span>
						</h1>

						<ProgressBar />
					</div>
				</div>
			)}
		</div>
	);
}
